import React from 'react';
import VisorRA from './components/VisorRA';
import './App.css';

function App() {
  return (
    <div className="App min-h-screen bg-gray-50 p-4">
      <main className="max-w-4xl mx-auto">
        <VisorRA />
      </main>
    </div>
  );
}

export default App;